import { Controller } from "@hotwired/stimulus"
import * as Routes from "routes"

export default class extends Controller {
  static targets = ["existingInfectionReports", "infectionReportLink" ]

  connect() {
    $(this.existingInfectionReportsTarget).on("select2:select", function () {
      let event = new Event("change", { bubbles: true })
      this.dispatchEvent(event)
    })

  }

  reportChange(event) {
    this.infectionReportLinkTarget.href = Routes.admin_infection_report_path(event.target.value)
  }

  enableExistingInfectionReports(_event) {
    this.existingInfectionReportsTarget.disabled = false
  }

  disableExistingInfectionReports(_event) {
    this.existingInfectionReportsTarget.disabled = true
  }
}
